import ConfirmationModal from './ConfirmationModal';
import { msalInstance } from 'contexts/Provider';
import { loggedInUser } from 'hooks/use-logged-in-user';

const LogoutModal: React.VFC = () => {
  const { isLoggingOut, setIsLoggingOut } = loggedInUser.useController();

  const cancelConfirmation = () => {
    setIsLoggingOut(false);
  };

  const confirmLogout = () => {
    sessionStorage.clear();

    msalInstance.logoutRedirect({
      onRedirectNavigate: (url) => {
        // Return false if you would like to stop navigation after local logout
        return false;
      }
    });
  };

  return (
    <ConfirmationModal
      open={isLoggingOut}
      title="Authentication - Logout"
      message="Are you sure you want to logout?"
      onCancel={cancelConfirmation}
      onConfirm={confirmLogout}
    />
  );
};

export default LogoutModal;
